import _ from 'lodash';
import React, { Component } from 'react';
import ButtonList from './button-list';
import ProductTitlePrice from './product-title-price';
import Carousel from './image-carousel';

//This class based component contains major part of product details
//including color swatches, add-to-cart, inventory dropdowns, available stock
export default class ProductDetail extends Component {
    constructor(props) {
        super(props)

        this.state = {
            id: '',
            color: 'naked-1',
            stock: '',
            bandSize: '32E'
        }
    }

    //this is used to update 'CUP Size' select based on selection of
    // band size
    handleChange(e) {
        this.setState({
            bandSize: e.target.value
        })
    }

    //groupBy is used for grouping the 'variants' data using option1
    // as category to separate data based on click of color swatch
    groupBy(input) {
        const groupByColor = _(this.props.variants)
            .groupBy(x => x.option1)
            .map((value, key) => ({ color: key, details: value }))
            .value();

        let data = [];
        for (let elem of groupByColor) {
            if (elem.color === input) {
                for (let i = 0; i < elem.details.length; i++) {
                    data.push(elem.details[i])
                }
            }
        }
        return data;
    }

    //addToBag shows basic alert for item added to cart
    addToBag() {
        return alert('Added ' + this.props.title + ' ' + this.state.bandSize + ' - to the cart');
    }

   

    render() {
        let val = this.groupBy(this.state.color).filter(function (el) {
            return el.inventory_quantity >= 10;
        });

        //filter by band andd cup selection to extract price of the item
        const filterBySize = val.filter(x => {
            return x.option2 === this.state.bandSize;
        });
        return (
            <div className='product-detail'>
                <ProductTitlePrice
                    price={filterBySize}
                    title={this.props.title} />

                {/* image carousel shown in mobile and tablet views     */}
                <Carousel
                    images={this.props.images} />
                <div className='clicked-color'> COLOR:
                    <div className='color-name'> {this.state.color} </div>
                </div>

                {/* function based component to get list of swatch buttons */}
                <ButtonList
                    setColor={val}
                    onButtonClick={color => this.setState({ color })}
                    variants={this.props.variants} />

                <div className='product-stock-text'> STOCK:
                    <div className='product-stock-number'>
                        {filterBySize.map((x) => <span key={x.id} > {x.inventory_quantity} </span>)}
                    </div>
                </div>
                <div className='product-sizes'>
                    <div className='product-band-size' > BAND SIZE
                        <div>
                            <select className='band-size-select' name='bandSizeSelect' value={this.state.bandSize} onChange={this.handleChange.bind(this)}>
                                {val.map(x => <option key={x.id} value={x.option2}>{x.option2.slice(0, 2)}</option>)}
                            </select>
                        </div>
                    </div>
                    <div className='product-cup-size'> CUP SIZE
                        <div>
                            <select className='cup-size-select' value={this.state.bandSize} onChange={this.handleChange.bind(this)} >
                                {val.map(x => <option key={x.id} value={x.option2} >{x.option2.slice(2)}</option>)}
                            </select>
                        </div>
                    </div>
                </div>
                <div>
                    <button
                        onClick={() => this.addToBag()}
                        className='product-add-to-bag'>
                        ADD TO BAG
                    </button>
                </div>
            </div>
        )
    }

}


// WEBPACK FOOTER //
// ./src/components/product-detail.js